/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { RotatingLines } from "react-loader-spinner"
import RistoSliderFoto from './ristoSliderFoto'
import Travelpayouts from './affiliazioni/travelpayouts'
import 'swiper/css'

function Ristoranti({ flag, flag2, flag3, onChiudi, distanza, lat, lng, idEvento, dettagliIsOpen }) {
    const navigate = useNavigate()
    const [ristoranti, setRistoranti] = useState([])//trovati in google API places(new)
    const [ristorantiMYSQL, setRistorantiMYSQL] = useState([])//trovati in MYSQL
    const [ristorante, setRistorante] = useState(null)// in google
    const [ristorante2, setRistorante2] = useState({
        datiDaGoogle: '',
        città: '',
        img: '',
        video: ''
    })// in MYSQL
    const [fillPercentage, setFillPercentage] = useState()// rating rist da google Places
    const [isOpen, setIsOpen] = useState({ text: '', color: 'black' })// booeliano per sapere se il risto è ap. o chiu.
    const [msg, setMsg] = useState({ ristoNotFound: null })
    // Stili per il contenitore 'RATING' (background vuoto)
    const containerStyle = {
        width: '95%',
        height: '20px',
        backgroundColor: '#e0e0e0', // Grigio chiaro per la parte vuota
        borderRadius: '10px',
        overflow: 'hidden',
        border: '1px solid #ccc',
        margin: '1em auto'
    }
    // Stili per il riempimento ?RATING' (background pieno)
    const fillStyle = {
        height: '100%',
        width: `${fillPercentage}%`, // Larghezza dinamica
        backgroundColor: '#fdc408', // Verde per la parte piena
        transition: 'width 0.5s ease-in-out', // Animazione fluida
    }
    const getRestaurant = async (e) => {
        try {
            const res = await axios.get(`/restaurants/${distanza}/${lat}/${lng}`)//places oggetto e routingSummaries alro oggetto
            if (Object.keys(res.data.ristoByGooglePlaces).length !== 0) {
                document.getElementsByClassName('rotary')[0].style.display = 'none'
                const wer = res.data.ristoByGooglePlaces.places.filter(x => !x.displayName.text.includes('Hotel'))//tolgo gli hotel 
                const nuovoArray = wer.map((item, index) => ({//places e routingSummaries in unico oggetto
                    ...item,
                    ...res.data.ristoByGooglePlaces.routingSummaries[index]
                }))
                setRistoranti(nuovoArray)//risto trovati in Google API Places(new)
                setRistorantiMYSQL(res.data.ristoBySQL)//risto trovati in MYSQL
            } else {
                setMsg({ ristoNotFound: '*** Nessun ristorante trovato ***' })
                document.getElementsByClassName('rotary')[0].style.display = 'none'
            }
        } catch (err) { console.log(err) }
    }
    const dettagli = (e) => {//per google places
        const rist = ristoranti.filter((item, index) => index === e)[0]
        setRistorante(rist)
        if (rist.currentOpeningHours) {
            setIsOpen(prev => ({
                ...prev,
                text: rist.currentOpeningHours.openNow === false ? 'CHIUSO' : 'APERTO',
                color: rist.currentOpeningHours.openNow === false ? 'red' : 'green'
            }))
        }
        // Assicuriamo che il rating sia tra 0 e 5
        const safeRating = (Math.min(Math.max(rist.rating, 0), 5))
        // Calcolo della percentuale di riempimento (es: 3.5 -> 70%)
        setFillPercentage((safeRating / 5) * 100)
        dettagliIsOpen('secondoRistoGoogle')
    }
    const dettagli2 = (e) => {//per MYSQL
        const rist = ristorantiMYSQL.filter(item => item.id === e)[0]
        setRistorante2(rist)
        if (rist.datiDaGoogle?.[0].currentOpeningHours)
            if (rist.datiDaGoogle?.[0].currentOpeningHours.openNow === false) {
                setIsOpen({ text: 'CHIUSO', color: 'red' })
            } else {
                setIsOpen({ text: 'APERTO', color: 'green' })
            }
        // Assicuriamo che il rating sia tra 0 e 5
        const safeRating = (Math.min(Math.max(rist.datiDaGoogle?.[0].rating, 0), 5))
        // Calcolo della percentuale di riempimento (es: 3.5 -> 70%)
        setFillPercentage((safeRating / 5) * 100)
        dettagliIsOpen('secondoRistoMysql')
    }
    useEffect(() => {
        if (flag === 'primoRistoranti' && ristoranti.length === 0 && lat) {
            setMsg({ ristoNotFound: null }); document.getElementsByClassName('rotary')[0].style.display = 'block'; getRestaurant()
        }
    }, [lat, flag])
    return (<>
        <div // BANNER PRINCIPALE LISTA DI TUTTI I RISTORANTI
            className={`divNotifiche${flag === 'primoRistoranti' || flag2 === 'secondoRistoGoogle' || flag2 === 'secondoRistoMysql'
                || flag3 === 'terzoRistoDesktop' ? 'Aperto' : ''}`} style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>

            <button style={{ fontSize: 'xx-large', border: 'none' }} onClick={() => { onChiudi() }}>◀
            </button>
            <span onClick={() => {
                if (!localStorage.getItem('logged')) { document.getElementById('banAggRist').style.display = 'block' }
                else navigate('/addRisto', { replace: true })
            }}
                style={{ marginLeft: '2em', fontWeight: '600', fontSize: '20px', color: 'blue', cursor: 'pointer' }}>
                <u>Aggiungi un ristorante</u>
            </span>

            <div className='border p-2' style={{ display: 'none' }} id='banAggRist'>
                <span style={{ cursor: 'pointer', float: 'right' }} onClick={() => { document.getElementById('banAggRist').style.display = 'none' }}>
                    <img src={require('../image/icons8-chiudi-macos-32.png')} alt='' />
                </span>
                <div className='text-center'>
                    Questo servizio richiede la registrazione.<br /> Se sei già registrato effettua l'accesso<br />
                    <Link to={{ pathname: `/` }} style={{ textDecoration: 'none', color: 'black' }}>
                        <button className='btn btn-primary mt-1' onClick={() => { document.body.style.overflow = "scroll" }}>Avanti</button>
                    </Link>
                </div>
            </div>
            <hr />

            <p className='mt-1 text-center rotary'>
                <RotatingLines strokeColor='silver' strokeWidth='5' animationDuration='5' width='26' />
            </p>

            <div style={{ margin: '0 3px', overflowY: 'scroll', height: '90%' }}>
                <p className='text-center fs-5'><i>{msg.ristoNotFound}</i></p>

                {ristorantiMYSQL.length !== 0 && // da MYSQL
                    ristorantiMYSQL.map((ristorante, index) => (
                        <div style={{ borderBottom: '1px solid lightgrey', display: 'grid', gridTemplateColumns: '1fr', gap: '5px', cursor: 'pointer', margin: '8px 0' }}
                            onClick={() => { dettagli2(ristorante.id) }} key={'mysql' + index}>
                            <p><span style={{ backgroundColor: 'gainsboro', borderRadius: '7px', padding: '3px', fontWeight: '600' }}>{ristorante.nome}</span><span style={{ opacity: '.6' }}>
                                <i>{ristorante.soggetto} - {ristorante.regione}</i> - {ristorante.città.toUpperCase()}</span>
                                <span style={{ fontSize: 'small', color: 'limegreen', float: 'right' }}> consigliato ✅</span>
                            </p>
                        </div>
                    ))}

                {ristoranti.length !== 0 && //da google
                    ristoranti.map((ristorante, index) => (
                        <div style={{ borderBottom: '1px solid lightgrey', display: 'grid', gridTemplateColumns: '1fr', gap: '5px', cursor: 'pointer', margin: '8px 0' }}
                            onClick={() => { dettagli(index) }} key={index}>
                            <p><span style={{ backgroundColor: 'gainsboro', borderRadius: '7px', padding: '3px', fontWeight: '600' }}>{ristorante.displayName.text}</span> <i style={{ opacity: '.6' }}>{ristorante.formattedAddress}</i></p>
                        </div>
                    ))}
            </div>
        </div>
        {/* ------------------------ BANNER DETTAGLI RISTOR SOLO DA GOOGLE --------------------------- */}
        <div className={`divNotifiche${flag2 === 'secondoRistoGoogle' || flag3 === 'terzoRistoDesktop' ? 'Aperto' : ''}`}
            style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <button style={{ fontSize: 'xx-large', border: 'none' }} onClick={onChiudi}> ◀
            </button><hr />
            {ristorante &&
                <div style={{ textAlign: 'center', overflowY: 'scroll', height: '90%' }}>
                    {/* ---------------- IMMAGINE ---------------------- */}
                    <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
                        {ristorante.photos.map((photo, index) => (
                            <div className="scrollmenu_risto" key={index + 'google'}>
                                <img src={`https://places.googleapis.com/v1/${photo.name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=250&maxHeightPx=250`}
                                    style={{ width: '22em', height: '18em', objectFit: 'cover' }} role="button" onClick={() => {
                                        dettagliIsOpen('terzoRistoGoogle')
                                    }} alt='' />
                            </div>
                        ))}
                    </div>

                    {/* ----------------- NOME E INDIRIZZO ---------------  */}
                    <div className='mt-5 mb-5'>
                        <div style={{ textAlign: 'left', fontSize: 'x-large', margin: '0 10px', fontFamily: 'serif' }}>
                            <p>{ristorante.displayName.text}</p>
                            <p style={{ fontSize: 'large', opacity: '.8' }}>{ristorante.formattedAddress}</p>
                            {/* ------------- CHIUSO O APERTO --------------- */}
                            {isOpen.color &&
                                <p style={{ color: isOpen.color, fontSize: 'medium', fontFamily: 'sans-serif' }}>
                                    {isOpen.text}
                                </p>
                            }
                            <p className='fs-6'>
                                <img src={require('../image/icons8-telefono-cellulare-48.png')} width={'30px'} alt='' /> {ristorante.nationalPhoneNumber}
                            </p><hr />
                            <p className='fs-5'>
                                <img src={require('../image/icons8-visita-24.png')} alt='' /> {(ristorante.legs[0].distanceMeters / 1000).toFixed(1)} km
                            </p>
                            <Travelpayouts restaurantName={ristorante.displayName.text} address={ristorante.formattedAddress} />
                        </div><hr />
                        {/* ------------------ VALUTAZIONE ------------------- */}
                        <p className='text-start ms-2 fs-5'>Valutazione: {ristorante.rating}</p>
                        <div style={containerStyle}> <div style={fillStyle}></div>
                        </div>  <br /><br />
                    </div>
                </div>
            }
        </div>
        {/* ------------------------ BANNER DETTAGLI RISTOR DA MYSQL E foto DA GOOGLE --------------------------- */}
        <div className={`divNotifiche${flag2 === 'secondoRistoMysql' || flag3 === 'terzoRistoDesktop' ? 'Aperto' : ''}`}
            style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={() => {
                    setTimeout(() => { document.getElementById('fotoMenu').style.display = 'none'; onChiudi() }, 200)
                    if (ristorante2.video) {
                        const lp = document.getElementById('videoPreview')
                        lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                    }
                }}>
                ◀
            </button><hr />
            {ristorante2 &&
                <div style={{ textAlign: 'center', overflowY: 'scroll', height: '90%' }}>
                    {/* ---------------- IMMAGINE ---------------------- */}
                    {ristorante2.datiDaGoogle ? // da google
                        <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
                            {ristorante2.datiDaGoogle[0].photos.map((photo, index) => (
                                <div className="scrollmenu_risto" key={index + 'asdrt'}>
                                    <img src={`https://places.googleapis.com/v1/${photo.name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=250&maxHeightPx=250`}
                                        style={{ width: '21.5em', height: '17.8em', borderRadius: '10px' }} role='button'
                                        onClick={() => { dettagliIsOpen('terzoRistoMysql') }} alt='' />
                                </div>
                            ))}
                        </div> :
                        <div>
                            {ristorante2.img && // daMYSQL
                                <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
                                    <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
                                        {ristorante2.img.split(',').map((photo, index) => (
                                            <div className="scrollmenu_risto" key={index + 'cvghj'}>
                                                <img src={`https://leuro-bucket.s3.amazonaws.com/${photo}`}
                                                    style={{ width: '21.5em', height: '17.8em', borderRadius: '10px', objectFit: 'cover' }} role='button' alt=''
                                                    onClick={() => { dettagliIsOpen('terzoRistoMysql') }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    {/* ----------------- NOME, INDIRIZZO, TEL, EMAIL, CHIUSO O APERTO ---------------  */}
                    <div className='mt-5'>
                        <div style={{ textAlign: 'left', fontSize: 'x-large', margin: '0 10px', fontFamily: 'serif' }}>
                            <p>{ristorante2.nome}</p>
                            <div style={{ fontSize: 'large', opacity: '.8' }}>
                                <p> {ristorante2.soggetto} </p>
                                <p style={{ marginTop: '-15px' }}>{ristorante2.regione} - {ristorante2.città.toUpperCase()}</p>
                            </div>
                            {/* ------------- CHIUSO O APERTO --------------- */}
                            {ristorante2.datiDaGoogle &&
                                <p style={{ color: isOpen.color, fontSize: 'medium', fontFamily: 'sans-serif' }}>
                                    {isOpen.text}
                                </p>
                            }
                            {ristorante2.telefono &&
                                <p className='fs-6'>
                                    <img src={require('../image/icons8-telefono-cellulare-48.png')} width={'30px'} alt='' /> {ristorante2.telefono}
                                </p>
                            }
                            <p className='fs-6'>
                                <img src={require('../image/icons8-nuovo-messaggio-48.png')} width={'30px'} alt='' /> {ristorante2.emailUser}
                            </p>
                            <hr />
                            <p className='fs-5'>
                                <img src={require('../image/icons8-visita-24.png')} alt='' /> {(ristorante2.distanza / 1000).toFixed(1)} km
                            </p>
                        </div>
                    </div>

                    {/* ------------------- MENU + RATING ------------------ */}
                    <div>
                        <p className='text-primary fs-5 text-start ms-2' role="button" onClick={() => {
                            const qw = document.getElementById('fotoMenu').style.display
                            if (qw === 'none') { document.getElementById('fotoMenu').style.display = 'block' } else document.getElementById('fotoMenu').style.display = 'none'
                        }}><u>scopri il menù</u></p>
                        <div id='fotoMenu' style={{ display: 'none' }}>
                            {ristorante2.img && ristorante2.img.includes('menù') ?
                                <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }} id='fotoMenu'>
                                    {ristorante2.img.split(',').toReversed().map((photo, index) => (
                                        <div className="scrollmenu_risto" key={index + 'yhjo'}>
                                            <img src={`https://leuro-bucket.s3.amazonaws.com/${photo}`} ù
                                                style={{ width: '21.5em', height: '17.8em', borderRadius: '10px', objectFit: 'cover' }} alt='' />
                                        </div>
                                    ))}
                                </div> :
                                <p style={{ opacity: '.7', textAlign: 'left', margin: '-10px 0 0 10px' }}>niente da mostrare</p>
                            }
                        </div>

                        {/* ------------------ Valutazione ------------------- */}
                        {ristorante2.datiDaGoogle &&
                            <div className='mt-5'>
                                <p className='text-start ms-2 fs-5'>Valutazione: {ristorante2.datiDaGoogle[0].rating}</p>
                                <div style={containerStyle}> <div style={fillStyle}></div>
                                </div>
                            </div>
                        }
                    </div>

                    {/* ----------------- VIDEO -------------- */}
                    <div>
                        {ristorante2.video &&
                            <div style={{ border: '1px solid lightgrey', borderRadius: '5px', padding: ' 15px', marginTop: '1em' }}>
                                <div className='text-center mt-3'>
                                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${ristorante2.video}`} id={'videoPreview'}
                                        style={{ width: '99%', maxHeight: '200px', borderRadius: '5px' }} controls />
                                </div>
                            </div>
                        }
                    </div>

                    {/* -------------------- LINK ------------------ */}
                    <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '15px 5px', marginTop: '2rem' }}>
                        <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                        {ristorante2.url &&
                            <div className='btn btn-warning'>
                                <a href={ristorante2.url} style={{ textDecoration: 'none', color: 'navy' }} target='_blank'>Sito web</a>
                            </div>
                        }
                        {ristorante2.fb &&
                            <span style={{ backgroundColor: 'royalblue', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                <a href={ristorante2.fb} style={{ textDecoration: 'none', color: 'white', fontSize: 'x-large' }} target='_blank'><b>f</b></a>
                            </span>
                        }
                        {ristorante2.youtube &&
                            <span style={{ marginLeft: '1px', padding: '5px 13px' }}>
                                <a href={ristorante2.youtube} style={{ textDecoration: 'none', color: 'white' }} target='_blank'>
                                    <img src={require('../image/icons8-instagram-48.png')} alt='' />
                                </a>
                            </span>
                        }
                    </div>
                    <br /><br /><br />
                </div>
            }
        </div>
        <RistoSliderFoto ristorante={ristorante} flag3={flag3} ristorante2={ristorante2} />
    </>
    )
}
export default Ristoranti